import { ShieldCheck, ShieldAlert, AlertOctagon } from "lucide-react";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

const LEVELS = {
    green: {
        cls: "border-ok text-ok bg-ok/10",
        icon: ShieldCheck,
        label: "OK",
        title: "Extraction IA fiable",
    },
    amber: {
        cls: "border-warn text-warn bg-warn/10",
        icon: ShieldAlert,
        label: "À vérifier",
        title: "Extraction IA douteuse — à vérifier",
    },
    red: {
        cls: "border-danger text-danger bg-danger/10",
        icon: AlertOctagon,
        label: "Suspect",
        title: "Extraction IA probablement incomplète",
    },
};

export default function ReliabilityBadge({ reliability, devisId, compact = false }) {
    if (!reliability) return null;
    const meta = LEVELS[reliability.level] || LEVELS.green;
    const Icon = meta.icon;
    // Don't show GREEN badges by default to reduce noise — only flag problems
    if (reliability.level === "green") return null;
    const issues = reliability.issues || [];
    return (
        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        className={`pill ${meta.cls} cursor-help`}
                        data-testid={`reliability-badge-${devisId}`}
                        title={meta.title}
                    >
                        <Icon className="w-3 h-3" strokeWidth={2} />
                        {compact ? "" : meta.label}
                    </span>
                </TooltipTrigger>
                <TooltipContent className="max-w-sm rounded-none border-ink bg-white text-ink p-3 text-left">
                    <div className="font-heading font-bold mb-1.5 text-sm flex items-center gap-1.5">
                        <Icon className="w-3.5 h-3.5" strokeWidth={2} />
                        {meta.title} · score {reliability.score}/100
                    </div>
                    {issues.length > 0 ? (
                        <ul className="text-xs space-y-1 list-disc list-inside">
                            {issues.map((it, i) => (
                                <li key={`${it.slice(0, 24)}-${i}`}>{it}</li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-xs text-ink-soft">
                            Aucun problème détecté.
                        </p>
                    )}
                    <p className="text-[10px] text-ink-soft mt-2 italic">
                        Conseil : ouvrez le PDF original et comparez avec le total détecté.
                    </p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
